import React, { useRef, useEffect } from 'react'
import { gsap, ScrollTrigger } from 'gsap/all';
import { Fancybox, Carousel, Panzoom } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox.css";
import PageLayout from './PageLayout'
import { taxtReveal, timeToReadyTl } from '../utils/gsapService';
import TextSlide from '../components/textSlide/TextSlide';
import logoImg from '../assets/images/logo___1.png'
import bottlesImg from '../assets/images/bottles.png';
import videoBg from '../assets/images/video-bg.png';
import aboutBg from '../assets/images/about-bg.png';
import PlayButton from '../components/UI/PlayButton';
const About = () => { 
  gsap.registerPlugin(ScrollTrigger); 
  const headingLine = useRef(null);
  const desLine = useRef(null); 
  const logoWrap = useRef(null); 

  useEffect(() => { 
    let textRevealTl = null;
    const aniStart = setTimeout(()=>{ 
      textRevealTl = taxtReveal([headingLine.current, desLine.current], headingLine.current, logoWrap.current);
      ScrollTrigger.refresh();
    }, timeToReadyTl.firstDelay);
    ScrollTrigger.refresh();  


    return () => {
      if(textRevealTl != null){ 
        textRevealTl.tl.kill();
        textRevealTl.Lines.revert();  
      }
      clearTimeout(aniStart);
    };

    

  }, []); 


  return (
    <PageLayout bodyClassName={["dark-header", "about-page"]}>  
      <section className="about-top-section">
        <div className="container">
          <div className="row">
            <div className="col-lg-8 ms-lg-5">
              <div className="text-content-wrap">
                <h1 className="title-md text__light" ref={headingLine}>History</h1>
                <p ref={desLine}>Saint Cloud™ is a Kentucky Straight Bourbon, Crafted by Ray Walker using his unique perspective and vision from making Grand Cru wines in Burgundy, France. Ray excelled in making wines of character. His signature was blending hard work, tradition and an unrelenting pursuit of beauty through simplicity.</p>
              </div>
            </div>
            <div className="col-lg-2 d-flex align-items-center">
              <div ref={logoWrap} className="logo___wrap"><img src={logoImg} alt="" /></div>
            </div> 
          </div>
        </div>
      </section>
      <section className="about-info-section">
        <div className="bg-top" style={{backgroundImage:`url(${aboutBg})`}}></div>
        <div className="bg-bottom"></div>
        <div className="container text-center">
          <div className="bottles-wrapper">
            <img src={bottlesImg} alt="" />
          </div>
          <div className="text-content-wrap mb-150">
            <h2 className="text-md text__light">His focus is to bring a unique vision to the Kentucky Bourbon landscape,</h2>
            <div className="col-lg-8 mx-auto">
            <p>based on exceptional quality. Saint Cloud is a labor of love, created to bridge the connection to Ray’s family which dates back in Kentucky since the start of the nineteenth-century.</p>
            </div>
          </div>
          <div className="video-box-wrapper">
            <div className="bg" style={{backgroundImage:`url(${videoBg})`}}></div>
            <PlayButton attr={{ 
              "data-fancybox":"video-gallery",
              href:"https://youtu.be/fEErySYqItI"
            }}/>   
          </div>
        </div>
      </section>
      <section className="about-content-section pt-150"> 
        <div className="container"> 
          <div className="text-content-wrap mb-3 mb-lg-0">
            <div className="row">
              <div className="col-lg-6">
                <h2 className="title-md">While in France,</h2>
                <p>Ray made appearances on Anthony Bourdain’s, “No Reservations”, as well as in publications such as the New York Times; Bloomberg; BusinessWeek; USA Today; LA Times; The Economist; New York Journal of Books and many more. He also wrote the LA Times Bestselling autobiography, “The Road to Burgundy” detailing his move from a career in finance in California to making critically acclaimed Grand Cru wines in the famed region of Burgundy, France.</p>
              </div>
              <div className="col-lg-6">
                <p>We believe in allowing each barrel to express its own individuality. To that point, the hallmarks of our bourbons aren’t confined to tasting notes, but rather high levels of quality and refinement. The bourbons that wear the Saint Cloud label are produced on a micro- scale. Barrels will hold the equivalent of between 110 and 200 bottles, depending on a multitude of factors which include (but are by no means limited to) age; location of storage; weather influences; and humidity.</p>
                <p>We target quality and refinement, without compromise. At Saint Cloud, we are driven by an unrelenting effort to provide singular experiences. Our pursuit includes finding the highest quality barrels, and delivering on exceptional packaging that is unmatched in the industry. All of our bourbons are sourced at varying stages, depending on the specific goals we are aiming for with each bourbon. Saint Cloud focuses on providing unique experiences that are guided by our vision as well as our direct input on the development of our bourbons.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
      <TextSlide/> 
    </PageLayout>
  )
}

export default About; 